import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import ProceedUtoP from "./proceedUtoP";
import UserToPoolOperations from "../api/pool_operations";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CustomDate from "./sub_components/date";

const UserToPool = () => {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.auth.currentUser);
  useEffect(() => {
    if (currentUser === null) {
      return navigate("/signin");
    }
  }, []);
  const [dataToShow, setDataToShow] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [statusChanged, setStautsChanged] = useState(false);
  const [filter, setFilter] = useState(false);
  const [tempPage, setTempPage] = useState(pageNumber);
  useEffect(() => {
    filter && setPageNumber(1);
    // setDataLoading(true);
    UserToPoolOperations.failed_user_to_pool(pageNumber)
      .then((response) => {
        setDataLoading(false);
        setDataToShow(response.data.list);
       
        setTotalPages(response.data.total_pages);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [pageNumber, statusChanged]);
  const increasePage = () => {
    if (tempPage < totalPages) {
      setPageNumber(parseFloat(pageNumber) + 1);
      setTempPage(pageNumber);
      setTempPage(parseFloat(tempPage) + 1);
    }
  };

  const decrPage = () => {
    if (tempPage > 1) {
      setPageNumber(parseFloat(pageNumber) - 1);
      setTempPage(pageNumber);
      setTempPage(parseFloat(tempPage) - 1);
    }
  };
  const handleChange = (event) => {
    setTempPage(event.target.value);
  };

  const assignPage = (e) => {
    if (e.key === "Enter") {
      setPageNumber(e.target.value);
    }
  };
  return (
    <div className="content">
      <div className="container-fluid pt-4 pb-4 px-4">
        <div className="page-title">
          <h1>User to pool</h1>
        </div>

        <div className="text-center rounded p-4 table-bg">
          <div className="table-responsive">
            <table className="table text-start align-middle table-bordered table-hover mb-0 text-center table-style table-bet-rounds">
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">User ID</th>
                  <th scope="col">Network ID</th>
                  <th scope="col">Topup</th>
                  <th scope="col">previous Balance</th>
                  <th scope="col">Token</th>
                  <th scope="col">User to pool</th>
                  <th scope="col">Pool to user</th>
                  <th scope="col">Created At</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {dataLoading ? (
                  <tr>
                    <td colspan="10">
                      <div className="loader-container">
                        <div className="lds-ring">
                          <div></div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : (
                  dataToShow.map((obj) => {
                    return (
                      <tr key={obj.id}>
                        <td>{obj.id}</td>
                        <td>{obj.user_id}</td>
                        <td>{obj.network_id}</td>
                        <td>{obj.top_up}</td>
                        <td>{obj.previous_balance}</td>
                        <td>{obj.token ? "USDT" : "Native"}</td>
                        <td>{obj.user_to_pool_status}</td>
                        <td>{!obj.token ? "NA" : obj.pool_to_user_status}</td>
                        <td>
                          <CustomDate date={obj.created_at} />
                        </td>
                        <td>
                          <ProceedUtoP
                            statusChanged={statusChanged}
                            setStautsChanged={setStautsChanged}
                            id={obj.id}
                            token={obj.token}
                            user_to_pool_status={obj.user_to_pool_status}
                            pool_to_user_status={obj.pool_to_user_status}
                          />
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
            <div className="pagination-buttons-container width my_row end">
              <div className="next-pre-btn my_row align_center space-between width-15">
                <div className="pre-btn">
                  <button
                    style={{
                      background: "transparent",
                      border: "none",
                    }}
                    className="white"
                    onClick={decrPage}
                  >
                    <ArrowBackIosNewIcon />
                  </button>
                </div>
                <span className="white">
                  <input
                    type="number"
                    value={tempPage}
                    style={{
                      maxWidth: "50px",
                      heigh: "10px",
                      background: "transparent",
                      border: "none",
                      color: "white",
                      textAlign: "center",
                    }}
                    onChange={handleChange}
                    onKeyPress={assignPage}
                  />
                  / {totalPages}
                </span>
                <div className="next-btn">
                  <button
                    className="white"
                    style={{
                      background: "transparent",
                      border: "none",
                    }}
                    onClick={increasePage}
                  >
                    <ArrowForwardIosIcon />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  // );
};

export default UserToPool;
